import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

const ACTIVITY_KEYS = [
  'pages.checkout.activityFeed.activity1',
  'pages.checkout.activityFeed.activity2',
  'pages.checkout.activityFeed.activity3',
  'pages.checkout.activityFeed.activity4',
  'pages.checkout.activityFeed.activity5',
]

export default function LiveActivityFeed() {
  const { t } = useTranslation()
  const [currentIndex, setCurrentIndex] = useState(0)
  const [isVisible, setIsVisible] = useState(true)

  useEffect(() => {
    const interval = setInterval(() => {
      setIsVisible(false)
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % ACTIVITY_KEYS.length)
        setIsVisible(true)
      }, 300)
    }, 4000)

    return () => clearInterval(interval)
  }, [])

  return (
    <div
      className={`bg-primary/5 border-primary/20 flex items-center gap-2 rounded-xl border px-4 py-3 transition-opacity duration-300 ${isVisible ? 'opacity-100' : 'opacity-0'}`}
    >
      <span className="text-lg">🔔</span>
      <p className="text-custom-black text-sm">
        {t(ACTIVITY_KEYS[currentIndex])}
      </p>
    </div>
  )
}
